{
  "register": "註冊",
  "login": "登錄",
  "label": {
    "phoneNumber": "手機號",
    "password": "密碼"
  },
  "placeholder": {
    "phoneNumber": "請輸入手機號",
    "password": "請輸入密碼"
  },
  "country": {
    "cn": "中國",
    "kr": "韓國",
    "gb": "英國",
    "ca": "加拿大",
    "br": "巴西",
    "vn": "越南"
  },
  "countryOrRegion": "國家/地區",
  "forgetPassword": "忘記密碼？",
  "noAccount": "還沒有帳號？<0>註冊<0/>",
  "toast": {
    "success": {
      "changeLoginPassword": "登入密碼修改成功",
      "sendVerificationCode": "驗證碼發送成功"
    },
    "error": {
      "loginFailed": "手機號或密碼錯誤",
      "loginRateLimited": "登入嘗試次數過多，請 15 分鐘後再試",
      "otpFailed": "驗證碼錯誤，請重新輸入或重新獲取",
      "otpVerificationRateLimited": "驗證碼嘗試次數過多，請 15 分鐘後再試",
      "sendVerificationCode": "驗證碼發送失敗",
      "sendVerificationCodeTooFast": "驗證碼請求過快，請 60 秒後重新獲取",
      "sendVerificationCodeQuotaReached": "驗證碼請求次數已達上限，請 15 分鐘後重試",
      "smsServiceUnavailable": "短信服務暫時不可用，請稍後重試",
      "notRegisteredPhoneNumber": "手機號未註冊",
      "serverError": "伺服器異常，請稍候重試",
      "networkError": "網路異常，請稍後重試",
      "timeoutError": "操作逾時，請稍後再試",
      "changeLoginPasswordFailed": "登入密碼修改失敗，請稍後重試",
      "noAccess": "IP不合法"
    }
  }
}
